import { render } from "./OrderWidget.vue?vue&type=template&id=bd072852&scoped=true"
import script from "./OrderWidget.vue?vue&type=script&lang=js"
export * from "./OrderWidget.vue?vue&type=script&lang=js"

import "./OrderWidget.vue?vue&type=style&index=0&id=bd072852&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/app.lensmark.kz/mini-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd072852"]])

export default __exports__